module.exports = __webpack_public_path__ + "img/logo.3069efc4.png";